<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-4 col-md-12 col-4 mb-4">
                    <h2>End Of Day</h2>
                    <EodTabs />
                    </div>
                    <div class="col-lg-8 col-md-12 col-8 text-right">
                        <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                            <i @click="searchCustomer()" class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                            <input v-on:keyup.enter="searchCustomer" v-model.trim="searchValue" class="form-control form-control-sm" type="text" placeholder="Search by customer name" aria-label="Search">
                            <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>
                        <button @click="openAddCustomerModal()" type="button" class="btn btn-success rounded"><i class="fas fa-user-plus"></i> ADD NEW CUSTOMER</button>
                        <button @click="openAddSchedulerModal()" type="button" class="btn btn-warning rounded"><i class="fas fa-calendar-plus"></i> ADD SCHEDULER</button>
                    </div>
                </div>
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 dashboard">
            <div class="row">
                <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl imstbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th
                                    scope="col"
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'customer' ? 'sort-asc' : '', sortOrder == 'DESC' && sortColumn == 'customer' ? 'sort-desc' : '']"
                                    @click="sort('customer')">Customer Name</th>
                                <th scope="col">Email</th>
                                <th scope="col">Added On</th>
                                <th scope="col" class="text-center">Action</th>
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="totalRows == 0 && !loading">
                                <td colspan="4"><p class="nodata">No data available</p></td>
                            </tr>
                            <tr v-for="(item, index) in schedulers" :key="item.id || index">
                                <td>{{ customerName(item) }}</td>
                                <td>
                                    <template v-if="emailList(item).length">
                                        <div class="listAcc" v-for="(email, i) in emailList(item)" :key="i">{{ email }}</div>
                                    </template>
                                    <span v-else>N/A</span>
                                </td>
                                <td>{{ formatDate(item.createdAt) }}</td>
                                <td class="text-center">
                                    <a @click="deleteScheduler(item)" class="btn ibtn btn-outline-danger" title="Remove from scheduler"><i class="fas fa-trash-alt"></i></a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getSchedulers(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{ totalRows }}</span>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <addcustomermodal
            v-if="addCustomerModalOpen"
            v-bind:customerData="newCustomer"
            @close="addCustomerModalOpen = false"
            @saved="$router.push('/reports/customers')"
        />
        <AddSchedulerModal
            v-if="addSchedulerModalOpen"
            @close="addSchedulerModalOpen = false"
            @saved="onSchedulerSaved()"
        />
    </div>
</template>

<script>
import config from "@/config";
import authService from "@/authService";
import EodTabs from "./EodTabs";
import AddSchedulerModal from "./reportAddSchedulerModal";
import addcustomermodal from "@/components/ims/ims-maintenance/ims-customers/ImsAddCustomerModal";

export default {
  name: "reportScheduler",
  components: {
    EodTabs,
    AddSchedulerModal,
    addcustomermodal
  },
  data () {
    return {
      loading: false,
      currentPage: 1,
      perPage: 10,
      searchValue: "",
      totalRows: 0,
      sortColumn: "customer",
      sortOrder: "ASC",
      schedulers: [],
      addSchedulerModalOpen: false,
      addCustomerModalOpen: false,
      newCustomer: {}
    };
  },
  methods: {
    customerName (item) {
      const first = item.customerFirstName ? item.customerFirstName[0] + ". " : ". ";
      return first + (item.customerLastName || "");
    },
    // customerEmailList comes as one comma-separated string, e.g. "a@x.com, b@y.com"
    emailList (item) {
      if (!item.customerEmailList) return [];
      return item.customerEmailList.split(",").map(e => e.trim()).filter(e => e);
    },
    formatDate (value) {
      if (!value) return "N/A";
      // API returns e.g. "2026-10-12 06:16:10.911 UTC"
      const m = this.moment.utc(value, "YYYY-MM-DD HH:mm:ss.SSS");
      return m.isValid() ? m.local().format("MM/DD/YYYY hh:mm A") : value;
    },
    openAddCustomerModal () {
      this.newCustomer = {};
      this.addCustomerModalOpen = true;
    },
    openAddSchedulerModal () {
      this.addSchedulerModalOpen = true;
    },
    onSchedulerSaved () {
      this.addSchedulerModalOpen = false;
      this.getSchedulers();
    },
    deleteScheduler (item) {
      const message = "Are you sure you want to remove " + this.customerName(item) + " from the scheduler?";
      this.$confirm(message, "Remove from scheduler", "", { confirmButtonText: "Delete", cancelButtonText: "No" }).then(() => {
        this.loading = true;
        const auth = {
          headers: { "org-token": authService.getOrgToken() }
        };
        const data = {
          deletedIds: [item.id],
          createdBy: authService.getUser().id,
          customerIds: []
        };
        this.$http
          .post(config.baseUrlAutoBidder + "/eod/email-scheduler", data, auth)
          .then(() => {
            this.loading = false;
            // go back a page if the last row on this page was removed
            if (this.schedulers.length == 1 && this.currentPage > 1) {
              this.currentPage--;
            }
            this.getSchedulers(this.currentPage);
          })
          .catch(e => {
            console.log(e);
            this.loading = false;
            this.$alert("Failed to remove from scheduler", "", "error");
          });
      }).catch(() => {});
    },
    searchCustomer () {
      this.getSchedulers();
    },
    clearSearch () {
      this.searchValue = "";
      this.getSchedulers();
    },
    sort (column) {
      this.sortColumn = column;
      this.sortOrder = this.sortOrder == "ASC" ? "DESC" : "ASC";
      this.getSchedulers();
    },
    getSchedulers (currentPage) {
      this.loading = true;
      if (!currentPage) {
        this.currentPage = 1;
      }
      const auth = {
        headers: { "org-token": authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlAutoBidder +
            "/eod/email-scheduler-list?page=" +
            (this.currentPage - 1) + // API pages are 0-based
            "&search=" +
            encodeURIComponent(this.searchValue) +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder,
          auth
        )
        .then(result => {
          this.schedulers = result.data.content || [];
          this.totalRows = result.data.pageInfo ? result.data.pageInfo.totalElements : 0;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    }
  },
  mounted () {
    this.getSchedulers();
  }
};
</script>
